import React, { useMemo } from "react";
import cronstrue from "cronstrue";
import { Card, TextField, Typography } from "@mui/material";
import { StyledCronJobFieldWrapper } from "./styles";

const CronJobInput = ({ value, error, setValue, onBlur, touched }) => {
  const [explanation, expError] = useMemo(() => {
    try {
      const explanation = cronstrue.toString(value, {
        throwExceptionOnParseError: true,
      });
      return [explanation, null];
    } catch (e) {
      return [null, e.message];
    }
  }, [value]);

  const hasError = error || expError;
  return (
    <Card variant="outlined">
      <StyledCronJobFieldWrapper>
          <Typography variant="body1">
            Frequency
          </Typography>
        <TextField
          value={value}
          type="text"
          variant="filled"
          name="cronJobExp"
          label={hasError ? "Cron Expression" : explanation}
          placeholder="* * * * *"
          error={hasError}
          helperText={hasError ? expError || error : ""}
          onChange={(e) => setValue(e.target.value)}
          onBlur={onBlur}
        />
      </StyledCronJobFieldWrapper>
    </Card>
  );
};

export default CronJobInput;
